export default function sortObjectsByTextProperty(
    objArray,
    sortingKey,
    isAscending = true
) {
    const sorted = objArray.sort((firstItem, secondItem) => {
        let a = firstItem[sortingKey]?.toLowerCase(),
            b = secondItem[sortingKey]?.toLowerCase();

        if (a < b) {
            return isAscending ? -1 : 1;
        }
        if (a > b) {
            return isAscending ? 1 : -1;
        }
        return 0;
    });

    return sorted;
}
